export const isChoiceField = (type: string): boolean =>
  type === 'select' || type === 'radio' || type === 'checkbox';
